import { useState, useEffect } from "react";
import { Badge } from "../ui/badge";
import { Type, AlertCircle } from "lucide-react";
import api from "../../lib/api";

function ClosingFramePreview({ session }) {
  const [brandKit, setBrandKit] = useState(null);
  useEffect(() => {
    if (!session.brand_kit_id) return;
    api.get('/brand-kits').then(res => {
      const kit = res.data.find(k => k.id === session.brand_kit_id);
      if (kit) setBrandKit(kit);
    }).catch(() => {});
  }, [session.brand_kit_id]);

  return (
    <div className="space-y-3">
      <div className="h-[200px] rounded-lg overflow-hidden relative bg-white border border-[#E2E4E7] max-w-md flex flex-col items-center justify-center" data-testid="closing-frame-preview">
        {brandKit?.logo_url && (
          <img src={brandKit.logo_url} alt="Logo" className="h-12 mb-3 object-contain" />
        )}
        <p className="text-base sm:text-lg font-bold tracking-wide uppercase mb-2 text-[#1A2238]"
          style={{ fontFamily: 'Belleza, serif' }}>
          {brandKit?.cta_text || 'BOOK A VIEWING'}
        </p>
        {brandKit?.phone && (
          <p className="text-sm font-medium tracking-wider text-[#1A2238]" style={{ fontFamily: 'Belleza, serif' }}>{brandKit.phone}</p>
        )}
      </div>
      {!session.brand_kit_id && (
        <div className="flex items-start gap-2 p-3 rounded-lg bg-amber-50 border border-amber-100">
          <AlertCircle size={14} className="text-amber-600 mt-0.5 shrink-0" />
          <p className="text-xs text-amber-800">Select a Brand Kit in the session setup to populate the closing frame</p>
        </div>
      )}
    </div>
  );
}

export function ClosingFrameSection({ session }) {
  return (
    <section className="bg-white rounded-xl border border-[#E2E4E7] overflow-hidden" data-testid="production-closing-frame">
      <div className="px-5 py-4 border-b border-[#E2E4E7] flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-violet-50 flex items-center justify-center">
            <Type size={18} className="text-violet-600" />
          </div>
          <div>
            <h3 className="font-semibold text-[#020B23] text-sm" style={{ fontFamily: 'Sora, sans-serif' }}>Closing Frame</h3>
            <p className="text-xs text-[#94969C]">Logo + CTA + contact details</p>
          </div>
        </div>
        {session.brand_kit_id && (
          <Badge className="text-xs bg-emerald-50 text-emerald-700 border-emerald-100">Ready</Badge>
        )}
      </div>
      <div className="p-5">
        <ClosingFramePreview session={session} />
      </div>
    </section>
  );
}
